import * as React from 'react';
import type { WrappedFieldProps } from 'redux-form';

interface OwnProps {
	className?: string;
}

type Props = OwnProps & WrappedFieldProps;

const Url: React.FC<Props> = (props) => {
	const { input, className } = props;

	if (!input.value) {
		return null;
	}

	const { displayPath, url } = input.value;

	return (
		<a
			className={className}
			href={url ?? undefined}
			rel="noopener noreferrer"
			target="_blank"
		>
			{displayPath}
		</a>
	);
};

export default React.memo(Url);
